export default __webpack_public_path__ + "static/media/ContentSuiteWhite.11bb6f90.svg";